module.exports = __webpack_public_path__ + "static/media/red-river.fdcd0414.svg";